export default __webpack_public_path__ + "static/media/blueLogo.c0070c38.png";